import { Flex } from 'foundations-components/components/Flex';
import { ACHubSpotLogo } from 'academy-navigation-lib/components/ACHubSpotLogo';
import { ACNavTabs } from 'academy-navigation-lib/components/ACNavTabs';
import { AC_PAGE_MAX_INLINE_SIZE } from 'academy-navigation-lib/components/ACPage/ACPage';
import { ACRouterLink } from 'academy-common-lib/components/ACRouterLink';
import { useIsPartner } from '../../partners/partnersQueries';
import { useNavPageHandlers } from '../navigationHooks.legacy';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const AcademyCompactNav = () => {
  const isPartner = useIsPartner();
  const {
    onTabClick
  } = useNavPageHandlers();
  return /*#__PURE__*/_jsx(Flex, {
    backgroundColor: "fill-surface-default",
    borderBlockEndColor: "border-core-subtle",
    borderBlockEndStyle: "solid",
    borderBlockEndWidth: "100",
    children: /*#__PURE__*/_jsx(Flex, {
      alignItems: "center",
      gap: "0",
      marginBlockEnd: "0",
      marginBlockStart: "400",
      marginInline: "auto",
      maxInlineSize: `${AC_PAGE_MAX_INLINE_SIZE}px`,
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        flexShrink: 0,
        gap: "400",
        children: [/*#__PURE__*/_jsx(ACRouterLink, {
          onClick: () => onTabClick('hubspot-academy'),
          to: "/",
          use: "unstyled",
          children: /*#__PURE__*/_jsx(ACHubSpotLogo, {
            size: "md"
          })
        }), /*#__PURE__*/_jsx(ACNavTabs, {
          isPartner: !!isPartner,
          onTabClick: onTabClick
        })]
      })
    })
  });
};